const t = {
  name: "ChevronLeftExtraSmall",
  dimensions: { width: 16, height: 16 },
  content: '<path d="M10.5608 5.00011L7.56077 8.00011L10.5608 11.0001L9.50011 12.0608L5.43945 8.00011L9.50011 3.93945L10.5608 5.00011Z" fill="currentColor"/>'
};
export {
  t as ChevronLeftExtraSmall
};
